import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EducationSubmit, EducationVerbose } from '@app/modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/employee-education/models/education.model';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EducationService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getEducations(employeeId: string, take?: number, skip?: number, sort?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    sort ? params = params.append('sort', sort) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.EDUCATION}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteEducation(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.EDUCATION}/${id}`, {
      headers: headers
    });
  }

  getEducation(employeeId: string, id: string): Observable<EducationVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.EDUCATION}/${id}`, {
      headers: headers
    });
  }

  updateEducation(employeeId: string, employeeEducation: EducationSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.EDUCATION}/${employeeEducation.id}`, employeeEducation, {
      headers: headers
    });
  }

  createEducation(employeeId: string, employeeEducation: EducationSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.EDUCATION}`, employeeEducation, {
      headers: headers
    });
  }
}
